import './style.css';

const { __ } = wp.i18n;

/**
 * Notification menu javascript initialization
 *
 * @param {Object} banner The banner DOM element
 */
const localStorageRendering = ( banner ) => {
	// Define the localstorage, notification DOM element dataset ID, close button and the localstorage items
	const { localStorage } = window;
	const { notification } = banner.dataset;
	const closeButton = banner.querySelector( '.notification-banner__close' );
	const storageItems = localStorage.getItem( 'notification-banner' );

	// Show all notes if localstorage is empty of items
	if ( storageItems === null ) {
		banner.classList.remove( 'is-hidden' );
	} // If not empty, show items which are NOT included in the localstorage items
	else if ( ! JSON.parse( storageItems ).includes( notification ) ) {
		banner.classList.remove( 'is-hidden' );
	}

	// Append items to storage array
	function appendToStorage( item, keyAndValue ) {
		// Check if item already exists in the storage
		let storeData = localStorage.getItem( 'notification-banner' );
		storeData = storeData ? JSON.parse( storeData ) : [];
		storeData.push( keyAndValue );
		localStorage.setItem( item, JSON.stringify( storeData ) );
	}

	// Apply the click event for the notification close button
	if ( closeButton ) {
		closeButton.addEventListener( 'click', () => {
			// Append notification to the localstorage items as an ID fetched from the DOM element's dataset
			appendToStorage( 'notification-banner', notification );
			banner.classList.add( 'is-animated' );

			// Let the "is-animated" class animation finish before hiding
			setTimeout( () => {
				banner.classList.add( 'is-hidden' );
			}, 300 );
		} );
	}
};

const init = () => {
	// Get the site notifications main container
	const siteNotifications = document.querySelector(
		'#site-notifications'
	);

	// If the site notifications container is not present, do nothing
	if (!siteNotifications)	return;

	// Prevent possible double initialization (by Cookiebot or other plugins)
	if (siteNotifications.classList.contains('is-ready')) {
		return;
	}

	// Get the lang parameter from the notification wrapper element's data-attribute
	const currentLang = siteNotifications.getAttribute('data-lang') ?? '';

	// Notifications REST endpoint location
	const notificationAjax = `${window.location.origin}/wp-json/evermade/notification/v1/list${currentLang && '?lang=' + currentLang}`;

	// If the Notifications REST endpoint is not present, return
	if (!notificationAjax) return;

	// Define the notification description and close button text
	const noteDesc = __( 'Notification description', 'evermade-notifications' );
	const noteClose = __( 'Close notification', 'evermade-notifications' );

	// Fetch notifications from the REST endpoint
	fetch(notificationAjax)
		.then((response) => response.json())
		.then((data) => {
			if (!data?.notifications.length) {
				return;
			}

			// Add custom class to the site notifications container when ready
			if (data) {
				siteNotifications.classList.add('is-ready');
			}

			data.notifications.forEach((notification) => {
				let notificationWrapperClasses = 'notification-banner is-hidden';

				let notificationLink = '';

				if (notification.link.url) {
					notificationLink = `<a class="notification-banner__link" href="${
						notification.link.url
					}"${notification.link.target && " target='_blank'"}>${
						notification.link.title
					}</a>`;
				}

				let notificationClose = '';

				if (notification.dismissable) {
					notificationWrapperClasses += ' is-dismissable';
					notificationClose = `<button class="notification-banner__close" title="${noteClose}"></button>`;
				}

				const notificationContent = `
					<div class="${notificationWrapperClasses}" data-notification=${notification.hash}>
						<div class="notification-banner__container">
							<div class="notification-banner__content">
								<p class="notification-banner__text">
									<span class="screen-reader-text">${noteDesc}:&nbsp;</span>
									${notification.text}
									${notificationLink}
								</p>
							</div>
							${notificationClose}
						</div>
					</div>
				`;

				siteNotifications.innerHTML += notificationContent;
			});

			// Apply the conditional localstorage rendering for each notification banner
			const notificationBanners =
				document.querySelectorAll('.notification-banner');

			if (notificationBanners.length) {
				notificationBanners.forEach((banner) => {
					localStorageRendering(banner);

					// Add custom class to body if notifications are present and at least one is not hidden
					if (!banner.classList.contains('is-hidden')) {
						document.body.classList.add(
							'has-notification-banner'
						);
					}
				});
			}
		})
		.catch((error) => console.error('Error:', error)); // eslint-disable-line no-console
};

document.addEventListener( 'DOMContentLoaded', init );
